import React, { useState } from 'react';
import cn from 'classnames';
import Pay from '@containers/Pay';
import { Form, Formik } from 'formik';
import style from './paymentScreens.module.scss';
import SimpleKeyBoard from '@components/common/formElements/SimpleKeyboard';
import Survey from '@containers/Survey';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import GiftCard from './giftCard';
import QrPayFromPhone from './QrPayFromPhone';
import tick from '@assets/images/tick_green.png';
import Modal from '@components/common/Modal';
import CashReturn from '@components/CashReturn';
import Button from '@components/common/LongPressButton';

const PaymentTerminalPaymentScreen = ({
  paymentType,
  sourceType,
  setTextToPayModelOpen,
  currenySymbol,
  paymentAmount,
  deviceInfo,
  // keyboardValue,
  // setPaymentType,
  unpaidAmount,
  totalAmount,
  setDrawerVisiblityProps,
  tipAmount,
  handleRouteCheck,
  handleCheck,
  logo,
  handleButtonClick,
  tipsList,
  active,
  // handlePrint,
  paymentCallBack,
  handleReceiptPopUpOpen,
  handleRetry,
  PaymentPageBtn,
  handleSplitEvenly,
  handlePayAnAmount,
  isCash,
  handleKeyboardValue,
  validatePayAnAmount,
  // hideSignature,
  subTotalAmount,
  handleSurveySubmit,
  isGiftCard,
  isSecurityCode,
  handleGiftCard,
  giftCardPayment,
  giftBalance,
  paidAmount,
  giftCardSupportsSwipe,
  openCardPopUp,
  giftCardNumber,
  handleFailureRoute,
  isCreditCard,
  errorMessage,
  handleProcessCreditError,
  // isDone,
  totalAmountForTip,
  charity,
  charityList,
  handleTipsRouteTo,
  applyDonation,
  handleGiftCancel,
  isQrScan,
  isKiosk,
  isTableTop,
  isServerApp,
  // supportsTips,
  tableData,
  successMessage,
  authResponse,
  handleBackButton,
  handleCreditCard,
  userInfo,
  receiptTypes,
  isCounter,
  handleHideCancelIcon,
  handleDirectToCashConfirmation,
  isExternalCreditCard,
  // ...props
}) => {
  const themeProperties =
    JSON.parse(window.sessionStorage.getItem('themeProperties')) || {};
  const getConfirmationLogo = () => {
    let image = logo;
    if (isKiosk) {
      image = themeProperties.kioskConfirmationPageImageUrl;
    } else if (isTableTop) {
      image = themeProperties.tableTopConfirmationPageImageUrl;
    } else if (isServerApp) {
      image = themeProperties.serverAppConfirmationPageImageUrl;
    }
    return image;
  };

  const StartScreen = () => {
    return (
      <div className="col-12 h-70 flex-column row mx-0 align-items-center justify-content-center py-2">
        {PaymentPageBtn?.map(item => {
          return (
            item && (
              <button
                key={item.name}
                type="button"
                onClick={() => {
                  item.click();
                }}
                className={cn(
                  'btn70 w-100 my-1 od-btn-primary btn-primary btn-ripple',
                  item.disabled ? style.opacity6 : ''
                )}
                disabled={item.disabled}
              >
                <div
                  className={cn('fs-25 text-uppercase', style.divForPayment)}
                >
                  {item.name}
                </div>
              </button>
            )
          );
        })}
      </div>
    );
  };

  const Fullcheck = () => {
    return (
      <div className="col-12 h-100 flex-column row mx-0 align-items-center justify-content-start my-4 py-3">
        {isQrScan && (
          <button
            type="button"
            className="btn70 rounded od-btn-primary btn-primary btn-ripple my-1 w-100 "
            onClick={() => handleCheck('qrPay')}
            disabled={isTableTop}
          >
            <div className="fs-18 text-uppercase">
              {LABEL().QR_PAY_FROM_PHONE}
            </div>
          </button>
        )}
        {sourceType !== 0 && !isTableTop && (
          <button
            type="button"
            disabled={sourceType === 7}
            className="btn70 rounded od-btn-primary btn-primary btn-ripple my-1 w-100 "
            onClick={() => setTextToPayModelOpen(true)}
          >
            <div className="fs-18 text-uppercase">{LABEL().TEXT_TO_PAY}</div>
          </button>
        )}
        {isCreditCard && (
          <button
            type="button"
            className={cn(
              'btn70 rounded my-2 w-100 od-btn-primary btn-primary btn-ripple '
            )}
            onClick={() => handleCheck('creditCard')}
            disabled={unpaidAmount === 0}
          >
            <div className={cn('fs-25 text-uppercase', style.divForPayment)}>
              {LABEL().CREDIT_CARD}
            </div>
          </button>
        )}

        {isExternalCreditCard && (
          <button
            type="button"
            className={cn(
              'btn70 my-1 w-100 od-btn-primary btn-primary btn-ripple ',
              subTotalAmount === 0 ? style.opacity6 : ''
            )}
            onClick={() => handleCheck('externalCreditCard')}
          >
            <div className={cn('fs-25 text-uppercase', style.divForPayment)}>
              {LABEL().EXTERNALCREDIT_CARD}
            </div>
          </button>
        )}
        {isGiftCard && (
          <button
            type="button"
            className={cn(
              'btn70 rounded my-2 w-100 od-btn-primary btn-primary btn-ripple '
            )}
            onClick={() => handleCheck('giftCard')}
            disabled={subTotalAmount === 0}
          >
            <div className={cn('fs-25 text-uppercase', style.divForPayment)}>
              {LABEL().GIFT_CARD}
            </div>
          </button>
        )}
        {isCash && (
          <Button
            type="button"
            className="btn70 rounded od-btn-primary btn-primary btn-ripple my-2 w-100 "
            onClick={() => handleCheck('cash')}
            onLongPress={() => {
              handleDirectToCashConfirmation(true);
              handleCheck('cash');
            }}
            disabled={isTableTop}
          >
            <div
              className={cn(
                'fs-25 text-uppercase text-underline',
                style.divForPayment
              )}
            >
              {LABEL().CASH}
            </div>
          </Button>
        )}
      </div>
    );
  };

  const Tips = () => {
    return (
      <div className="col-12 h-100 row mx-0">
        <div className="col-12 p-0 h-70 mt-5">
          {tipsList && tipsList.length > 0 ? (
            <>
              <div
                className={cn(
                  'col-12 fs-30 fw-700 m-0 my-4 od-text-primary text-center',
                  style.divForPayment
                )}
              >
                {LABEL().CHECK_TOTAL_TIP} {currenySymbol}
                {tableData &&
                  (tableData.totalAmount - tableData.paidAmount).toFixed(2)}
              </div>
              <div
                className={cn(
                  'col-12 fs-20 fw-700 od-text-primary m-0 mx-2',
                  style.divForPayment
                )}
              >
                {LABEL().PLEASE_SELECT_TIP}
              </div>
              <div
                className={cn('col-12 od-text-primary text-center pt-20 fs-20')}
              >
                <div className={style.wrapperPaymentTerm}>
                  {tipsList.map(item => {
                    return (
                      <div
                        key={item.key}
                        role="presentation"
                        onClick={() => {
                          handleKeyboardValue('');
                          handleButtonClick(item.key);
                        }}
                        className={cn(
                          'border border-color-secondary flex-grow d-flex flex-column align-items-center justify-content-center',
                          style.divForPayment,
                          item.key === active
                            ? 'bg-grey color-white od-btn-secondary'
                            : '',
                          style.gridItem
                        )}
                      >
                        <div style={{ padding: '2px' }}>{item.displayKey}</div>
                        {item.ruleType === 1 && ![4, 5].includes(item.id) && (
                          <div>
                            ({LABEL().CURRENCY_SYMBOL}
                            {(
                              (Number(totalAmountForTip) * Number(item.key)) /
                              100
                            ).toFixed(2)}
                            )
                          </div>
                        )}
                        {item.key === active && [4, 5].includes(item.id) && (
                          <div>
                            ({LABEL().CURRENCY_SYMBOL}
                            {Number(tipAmount).toFixed(2)})
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </>
          ) : null}
        </div>

        <div className="col-12 h-45 p-0 d-flex align-items-start justify-content-center py-2">
          <button
            type="button"
            className={cn(
              'btn90 od-btn-primary btn-primary btn-ripple w-100 my-1'
            )}
            onClick={() => handleCheck('tips')}
          >
            <div className={cn('fs-22 m-auto', style.divForPayment)}>
              {LABEL().TIP_CONTINUE}: {currenySymbol}
              {tableData &&
                (
                  tableData.totalAmount -
                  tableData.paidAmount +
                  Number(tipAmount)
                ).toFixed(2)}
            </div>
          </button>
        </div>
      </div>
    );
  };

  const Charity = () => {
    return (
      <div className="col-12 h-100 row mx-0">
        <div className="col-12 h-45 mb-1">
          <div className="fs-26 h-15 od-text-primary mb-1 text-center">
            {charity.name}
          </div>
          <div className="col-12 h-50 mb-1 text-center">
            <img src={charity.imageUrl} alt="" className="h-100" />
          </div>
          <div className="h-30 mb-2 col-12 p-0 overflowY">
            {charity.description}
          </div>
        </div>
        <div className="col-12 h-25 p-0">
          {charityList && charityList.length > 0 ? (
            <div className="col-12 od-text-primary fs-20 text-center p-0">
              <div className={style.charityWrapper}>
                {charityList.map(item => {
                  return (
                    <div
                      key={item.key}
                      role="presentation"
                      onClick={() => {
                        handleKeyboardValue('');
                        handleButtonClick(item.displayKey);
                      }}
                      className={cn(
                        'border rounded border-color-secondary flex-grow d-flex flex-column align-items-center justify-content-center',
                        item.displayKey === active
                          ? 'bg-grey color-white od-btn-secondary'
                          : ''
                      )}
                    >
                      <div>{item.displayKey}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null}
        </div>
        <div className="col-12 h-30 flex-column p-0 d-flex justify-content-end py-2">
          <button
            type="button"
            className="btn70 rounded od-btn-primary btn-primary btn-ripple w-100 my-1"
            onClick={() => applyDonation()}
          >
            <div className="fs-18">{LABEL().APPLY_DONATION}</div>
          </button>
          <button
            type="button"
            className="btn70 rounded od-btn-primary btn-primary btn-ripple w-100 my-1"
            onClick={() => handleTipsRouteTo()}
          >
            <div className="fs-18">{LABEL().SKIP_DONATION}</div>
          </button>
        </div>
      </div>
    );
  };

  const PaymentRecipt = () => {
    return (
      <div className="col-12 h-100 w-100 row mx-0 justify-content-center py-2 od-text-primary text-primary">
        {themeProperties?.serverAppLogoImageUrl && (
          <div className="col-12 py-2 row mx-0 align-items-center">
            <img
              src={themeProperties.serverAppLogoImageUrl}
              alt=""
              className="img-fluid mx-auto d-block h-100"
              style={{
                maxHeight: '250px',
              }}
            />
          </div>
        )}
        <div
          className={cn(
            'col-12 row justify-content-center align-items-center p-0 text-center fs-22 fw-600',
            style.divForPayment
          )}
        >
          {LABEL().PAYMENT_RECEIPT}
        </div>
        <div className="col-12 p-0">
          <button
            type="button"
            className="btn70 rounded od-btn-primary btn-primary btn-ripple my-1 w-100 "
            onClick={() => handleReceiptPopUpOpen('phone')}
          >
            <div
              className={cn('fs-18 text-uppercase', style.divForPayment)}
              style={{ fontSize: '20px' }}
            >
              {LABEL().TEXT}
            </div>
          </button>
          <button
            type="button"
            className="btn70 rounded od-btn-primary btn-primary btn-ripple my-1 w-100 "
            onClick={() => handleReceiptPopUpOpen('email')}
          >
            <div
              className={cn('fs-18 text-uppercase', style.divForPayment)}
              style={{ fontSize: '20px' }}
            >
              {LABEL().EMAIL}
            </div>
          </button>
          <button
            type="button"
            className="btn70 rounded od-btn-primary btn-primary btn-ripple my-1 w-100 "
            onClick={() => handleCheck('receipt')}
          >
            <div
              className={cn('fs-18 text-uppercase', style.divForPayment)}
              style={{ fontSize: '20px' }}
            >
              {LABEL().NO_RECEIPT}
            </div>
          </button>
        </div>
      </div>
    );
  };

  const PaymentConfirmationSuccess = () => {
    return (
      <>
        <div className="h-75 w-100">
          <div className="col-12 p-0 h-40 row mx-0 justify-content-center align-items-end">
            <div className="col-12 py-2 h-100 row mx-0 align-items-center">
              <img
                src={getConfirmationLogo()}
                alt=""
                className="img-fluid mx-auto d-block h-100"
                style={{
                  minHeight: '200px',
                  maxHeight: '350px',
                }}
              />
            </div>
          </div>
          <div className="h-35 mx-0 mb-5 row align-items-end col-12 justify-content-center text-center">
            <img
              src={tick}
              alt="fullimage"
              className="img-responsive center w-35"
            />
          </div>
          <div className="col-12 p-0 h-10 row text-center mx-0 justify-content-center align-items-center py-2">
            <div
              className={cn(
                'mb-2 fs-22 fw-100 od-text-primary text-primary text-uppercase',
                style.divForPayment
              )}
            >
              {LABEL().PAYMENT_NOW_COMPLETE}
            </div>
          </div>
          <div className="col-12 row m-0 align-items-center text-center">
            {Number(unpaidAmount) <= 0 ? (
              <>
                <div
                  className={cn(
                    'col-12 py-1 text-center fs-22 fw-700 mb-3 od-text-primary text-primary',
                    style.divForPayment
                  )}
                >
                  {CUSTOM_MESSAGES().GREAT_SERVING_YOU}
                </div>
                <div
                  className={cn(
                    'm-auto py-1 text-center fs-22 fw-700 od-text-primary text-primary',
                    style.divForPayment
                  )}
                >
                  {CUSTOM_MESSAGES().COME_BACK_SOON}
                </div>
              </>
            ) : (
              <div
                className={cn(
                  'col-12 py-1 text-center fs-25 fw-700 od-text-primary text-primary text-uppercase',
                  style.divForPayment
                )}
              >
                {CUSTOM_MESSAGES().CONTINUE_PAY_REMAINING_BALANCE}
              </div>
            )}
            {Number(unpaidAmount) > 0 && (
              <button
                type="button"
                className="btn50 fs-25 fw-700 od-btn-primary btn-primary btn-ripple my-1 w-100"
                onClick={() => handleRouteCheck()}
              >
                <div className={cn('fs-18', style.divForPayment)}>
                  {LABEL().CONTINUE}
                </div>
              </button>
            )}
          </div>
        </div>
        <div
          className={cn(
            'col-12 row justify-content-center mx-0 align-items-end py-1 text-center fs-18 fw-700 od-text-primary text-primary',
            style.divForPayment
          )}
        >
          {authResponse?.ticket &&
            authResponse?.ticket?.ticketPaymentTypeName === 'CreditCard' &&
            `Paid With ${authResponse.ticket.cardType
            } ending with ${authResponse.ticket.cardLast4.slice(-4)}`}
          {authResponse?.ticket &&
            authResponse?.ticket?.ticketPaymentTypeName === 'GiftCard' &&
            `Paid With ${authResponse.ticket.cardType
            } ending with ${authResponse.ticket.cardLast4.slice(-4)}`}
          {authResponse?.ticket &&
            authResponse?.ticket?.ticketPaymentTypeName === 'Cash' &&
            `Paid With ${authResponse.ticket.ticketPaymentTypeName}`}
        </div>
      </>
    );
  };

  const PaymentConfirmationError = () => {
    return (
      <div className="col-12 h-100 w-100 row mx-0 justify-content-center align-items-end py-2 od-text-primary text-primary">
        <div className="col-12 fs-26 p-0 text-center">
          {CUSTOM_MESSAGES().PAYMENT_PROCESSING_ERROR}
        </div>
        <div className="col-12 p-0">
          <button
            type="button"
            className="btn70 rounded od-btn-primary btn-primary btn-ripple my-1 w-100"
            onClick={() => handleRouteCheck()}
          >
            <div className="fs-18">{LABEL().DONE}</div>
          </button>
        </div>
      </div>
    );
  };

  const PaymentErrorRetry = () => {
    return (
      <div className="col-12 h-30 w-100 row mx-0 justify-content-center align-items-end py-2 od-text-primary text-primary">
        <div className="col-12 fs-26 p-0 text-center">
          {errorMessage || CUSTOM_MESSAGES().PAYMENT_PROCESSING_ERROR}
        </div>
        <div className="col-12 p-0" style={{ marginBottom: '30px' }}>
          <button
            type="button"
            className="btn70 rounded od-btn-primary btn-primary btn-ripple my-1 w-100"
            onClick={() => handleRetry()}
          >
            <div className="fs-18">{LABEL().RETRY}</div>
          </button>
        </div>
      </div>
    );
  };

  const SplitEvenly = () => {
    const [count, setCount] = useState(2);
    return (
      <div className="col-12 h-100">
        <div className="col-10 h-20 m-auto fs-36 fw-700 text-center">
          {CUSTOM_MESSAGES().SPLITTING_MESSAGE}
        </div>
        <div className={cn('col-12 h-60', style.padding15)}>
          <div className="row align-items-center h-100 justify-content-center">
            <div
              className="mr-4 od-dec-font-btn-color"
              role="presentation"
              onClick={() => count !== 2 && setCount(count - 1)}
            >
              <i className="fas fa-5x fa-minus-circle" />
            </div>
            <div className="fs-50 text-primary od-text-primary"> {count} </div>
            <div
              className="ml-4 od-inc-font-btn-color"
              role="presentation"
              onClick={() => setCount(count + 1)}
            >
              <i className="fas fa-5x fa-plus-circle" />
            </div>
          </div>
        </div>
        <div className="col-12 p-0 h-40 row mx-0 align-items-end py-2">
          <div
            className={cn('col-12 fs-36 fw-600 text-center', style.padding10)}
          >
            {CUSTOM_MESSAGES().EACH_PAY}: {LABEL().CURRENCY_SYMBOL}
            {Number(paymentAmount / count).toFixed(2)}
          </div>
          <button
            type="button"
            className="btn50 od-btn-primary btn-primary btn-ripple my-1 w-100"
            onClick={() =>
              handleSplitEvenly(count, Number(paymentAmount / count).toFixed(2))
            }
          >
            <div className="fs-36 fw-700">{LABEL().CONTINUE}</div>
          </button>
        </div>
      </div>
    );
  };

  const PayAnAmount = () => {
    return (
      <div className="col-12 h-100 w-100">
        <div className="col-11 h-20 m-auto fs-36 fw-700 text-center">
          {CUSTOM_MESSAGES().PAY_AN_AMOUNT}
        </div>
        <Formik
          enableReinitialize
          initialValues={{ payAnAmount: 0 }}
          onSubmit={handlePayAnAmount}
          validate={validatePayAnAmount}
        >
          {() => {
            return (
              <Form className="h-100">
                <div className="col-12 p-0 h-75">
                  <SimpleKeyBoard
                    containerClass="h-100"
                    isDotRequired
                    haveCurrency={`${LABEL().CURRENCY_SYMBOL}`}
                    name="payAnAmount"
                    type="withoutDone"
                    btnName={LABEL().CONTINUE}
                    customClass={style.textBoxHeight}
                    customClassInput={style.customInputStyle}
                  />
                </div>
                <div className="col-12 p-0 h-25 d-flex justify-content-center align-items-end py-2">
                  <button
                    type="submit"
                    className="btn50 od-btn-primary btn-primary btn-ripple my-1 w-100"
                  // onClick={() => handlePayAnAmount()}
                  >
                    <div className="fs-36">{LABEL().CONTINUE}</div>
                  </button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    );
  };

  const handlePayAnAmountModal = () => {
    return (
      <Modal isOpen={paymentType === 10}>
        <div className="px-2 text-right">
          <i
            role="presentation"
            onClick={() => handleBackButton().url()}
            className="fa fa-times fs-18"
            aria-hidden="true"
          />
        </div>
        <PayAnAmount />
      </Modal>
    );
  };

  const handleSplitEvenlyModal = () => {
    return (
      <Modal isOpen={paymentType === 9}>
        <div className="px-2 text-right">
          <i
            role="presentation"
            onClick={() => handleBackButton().url()}
            className="fa fa-times fs-26"
            aria-hidden="true"
          />
        </div>
        <SplitEvenly />
      </Modal>
    );
  };

  const IngenicoPayment = () => {
    return (
      <div className="col-12 h-100 w-100 row mx-0 justify-content-center align-items-end py-2 od-text-primary text-primary">
        <div className="col-12 fs-26 p-0 text-center">
          {CUSTOM_MESSAGES().PLEASE_CONTINUE_THE_PAYMENT}
        </div>
        <div className="col-12 fs-26 p-0 text-center">
          {CUSTOM_MESSAGES().PRESS_CONTINUE}
        </div>
        <div className="col-12 p-0">
          <button
            type="button"
            className="btn70 rounded od-btn-primary btn-primary btn-ripple my-1 w-100"
            onClick={() => handleCreditCard()}
          >
            <div className="fs-18">{LABEL().CONTINUE}</div>
          </button>
        </div>
      </div>
    );
  };

  const HandlePaymentScreenType = () => {
    switch (paymentType) {
      case 1:
        return StartScreen();
      case 2:
        return Fullcheck();
      case 3:
        return (
          <Pay
            paymentCallBack={paymentCallBack}
            handleFailureRoute={handleFailureRoute}
            handleProcessCreditError={handleProcessCreditError}
          />
        );
      case 4:
        return Tips();
      case 5:
        return PaymentRecipt();
      case 6:
        return PaymentConfirmationSuccess();
      case 7:
        return PaymentConfirmationError();
      case 8:
        return PaymentErrorRetry();
      case 9:
        return handleSplitEvenlyModal();
      case 10:
        return handlePayAnAmountModal();
      case 11:
        return <Survey handleSurveySubmit={handleSurveySubmit} />;
      case 12:
        return (
          <GiftCard
            isSecurityCode={isSecurityCode}
            giftBalance={giftBalance}
            paymentAmount={
              Number(totalAmount) - Number(paidAmount) + Number(tipAmount)
            }
            giftCardPayment={giftCardPayment}
            onSubmit={handleGiftCard}
            giftCardSupportsSwipe={giftCardSupportsSwipe}
            openCardPopUp={openCardPopUp}
            giftCardNumber={giftCardNumber}
            handleGiftCancel={handleGiftCancel}
          />
        );
      case 13:
        return <Charity />;
      case 14:
        return <QrPayFromPhone handleCheck={handleCheck} />;
      case 15:
        return <IngenicoPayment />;
      case 16:
        return (
          <CashReturn
            deviceInfo={deviceInfo}
            totalAmount={totalAmount}
            paymentType={paymentType}
            handleCheck={handleCheck}
            userInfo={userInfo}
            setDrawerVisiblityProps={setDrawerVisiblityProps}
            setErrorPopUp={setErrorPopUp}
          />
        );
      case 17:
        return (
          <CashReturn
            receiptTypes={receiptTypes}
            handleHideCancelIcon={handleHideCancelIcon}
            deviceInfo={deviceInfo}
            isCounter={isCounter}
            totalAmount={totalAmount}
            paymentType={paymentType}
            handleCheck={handleCheck}
            userInfo={userInfo}
            setDrawerVisiblityProps={setDrawerVisiblityProps}
            setErrorPopUp={setErrorPopUp}
          />
        );
      case 18:
        return (
          <CashReturn
            receiptTypes={receiptTypes}
            handleHideCancelIcon={handleHideCancelIcon}
            deviceInfo={deviceInfo}
            isCounter={isCounter}
            totalAmount={totalAmount}
            paymentType={paymentType}
            handleReceiptPopUpOpen={handleReceiptPopUpOpen}
            userInfo={userInfo}
            handleCheck={handleCheck}
            setDrawerVisiblityProps={setDrawerVisiblityProps}
            setErrorPopUp={setErrorPopUp}
          />
        );
      default:
        return <div />;
    }
  };

  return <>{HandlePaymentScreenType()}</>;
};

export default PaymentTerminalPaymentScreen;
